var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: { display: "flex", "flex-direction": "column", gap: "16px" }
    },
    [
      _c("div", { staticClass: "tags-wrapper" }, [
        _c(
          "div",
          { staticClass: "tags-container" },
          _vm._l(_vm.selectedCities, function(city) {
            return _c(
              "b-badge",
              {
                key: city,
                staticClass: "tag-item",
                attrs: { variant: "info" },
                on: {
                  click: function($event) {
                    return _vm.removeTag(city)
                  }
                }
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.getCityText(city)))]),
                _vm._v(" "),
                _c("b-icon-x-circle", { staticClass: "ml-1" })
              ],
              1
            )
          }),
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-dropdown",
        {
          staticClass: "mb-3",
          attrs: { text: "Selecione Municípios", variant: "primary" }
        },
        [
          _c(
            "b-dropdown-form",
            [
              _c(
                "b-form-group",
                { attrs: { label: "Buscar Município:" } },
                [
                  _c("b-form-input", {
                    staticClass: "mb-2",
                    attrs: { placeholder: "Digite para filtrar..." },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dropdown-scroll" },
                [
                  _vm.isLoading
                    ? _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-2" },
                        [
                          _c("b-spinner", {
                            attrs: {
                              small: "",
                              type: "grow",
                              label: "Carregando..."
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-2" }, [
                            _vm._v("Carregando cidades...")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.filteredCities, function(city) {
                    return _c(
                      "b-form-checkbox",
                      {
                        key: city.value,
                        attrs: { value: city.value },
                        on: { change: _vm.handleChange },
                        model: {
                          value: _vm.selectedCities,
                          callback: function($$v) {
                            _vm.selectedCities = $$v
                          },
                          expression: "selectedCities"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(city.text) + "\n        "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }